import { render, staticRenderFns } from "./PostOrder.vue?vue&type=template&id=e9feda00&scoped=true"
import script from "./PostOrder.vue?vue&type=script&lang=js"
export * from "./PostOrder.vue?vue&type=script&lang=js"
import style0 from "./PostOrder.vue?vue&type=style&index=0&id=e9feda00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9feda00",
  null
  
)

export default component.exports